import React from 'react';
import { useTranslation } from 'react-i18next';

import close from '../../../assets/close.svg';

import { ModalContainer } from '../../common';

export const StripeErrorModal = ({
  onClose = () => { },
  show = false,
}) => {
  const i18nPayments = useTranslation('paymentMethod');

  return (
    <ModalContainer
      onClose={onClose}
      show={show}
    >
      <div className="StripeModalMainContainer">
        <h1>{i18nPayments.t('stripe.errorTitle')}</h1>

        <button
          className="StripeModalClose"
          onClick={onClose}
          type="button"
        >
          <img alt="" src={close} />
        </button>

        <span>{i18nPayments.t('stripe.errorMessage')}</span>

        <button
          className="StripeOkButton"
          onClick={onClose}
          type="button"
        >
          {i18nPayments.t('stripe.ok')}
        </button>
      </div>
    </ModalContainer>
  );
};
